import axios from "axios";
import * as actionTypes from "../actionTypes";
import apiConstants from "../../constans/apiConstants";
import { toaster } from "../../utils/utils";
import { LOADER_TRUE } from "../actionTypes";
import * as actionType from "../actionTypes";

export const getProposalDetails = (proposalId) => (dispatch) => {
    dispatch({
        type: actionTypes.LOADER_TRUE,
    });
    axios
        .get(
        `${
            apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/get/proposal/${proposalId}`,
        {
            headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
            },
        }
        )
        .then((resp) => {
        dispatch({ type: "LOADER_FALSE" });
        // resp.data.body.mcustomerResponse.paymentDetails['totalPremiumPayable'] = 12654.123;
        dispatch({
            type: actionTypes.FETCH_PROPOSAL_DETAIL,
            data: resp.data.body.mcustomerResponse,
        });
        dispatch({
          type: actionType.PROPOSAL_DATA,
          payload: { ...resp.data.body.mcustomerResponse },
        });
        toaster("success", resp.data.message);
        })
        .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
            toaster("error", err.data.message);
        }
        });
    };

    export const payment_check = (proposalNumber) => {
    return (dispatch) => {
        dispatch({ type: "LOADER_TRUE" });
        axios
        .get(
            `${
            apiConstants().PROPOSEL_API_URL
            }api/v1/proposal/ops/payment/isValid?proposalNumber=${
            proposalNumber.proposal
            }`,
            {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token"),
            },
            }
        )
        .then((res) => {
            dispatch({ type: "LOADER_FALSE" });
            if (res && res.data) {
            dispatch({
                type: actionType.PAYMENT_CHECK,
                data: res.data,
            });
            if (res.data.body) {
                dispatch(getProposalDetails(proposalNumber.proposal));
            }
            toaster("success", res.data.message);
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADER_FALSE" });
            if (err && err.data) {
            toaster("error", err.data.message);
            }
        });
    };
    };

    export const sendEnach = (data, cb) => (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });
    axios
        .post(
        `${apiConstants().PROPOSEL_API_URL}api/v1/ops/eNACH/paymentBegin`,
        data,
        {
            headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
            },
        }
        )
        .then((resp) => {
        // toaster("success", resp.data.message);
        // dispatch({
        //   type: actionTypes.fetchProposalDetail,
        //   payload: resp.data.body.mcustomerResponse
        // });
        let newWindow = window.open();
        newWindow.location = resp.data.body.DATA;
        dispatch(getProposalDetails(data.proposalNumber));
        if (cb && resp.data.body) {
            cb(resp.data.body);
        }
        dispatch({ type: "LOADER_FALSE" });
        })
        .catch((err) => {
        toaster("error", err.data ? err.data.message : "FAILED");
        if (err.status === "401") {
            window.location.href = apiConstants.TRACKER_URL;
        }
        if (cb) {
            // cb(false)
        }
        dispatch({ type: "LOADER_FALSE" });
        });
    };

    export const checkIFSC = (code, cb) => {
    return (dispatch) => {
        dispatch({ type: "LOADER_TRUE" });
        axios
        .get(
            `${
            apiConstants().PROPOSEL_API_URL
            }api/v1/proposal/bank/info?ifsc=${code}`,
            {
            headers: {
                authorization: localStorage.getItem("token"),
            },
            }
        )
        .then((res) => {
            dispatch({ type: "LOADER_FALSE" });
            if (res && res.data) {
            dispatch({
                type: actionTypes.IFSC_PAYMENT,
                data: res.data,
            });
            if (res.data.status === "NOT_FOUND" && cb) {
                cb();
            }
            toaster("success", res.data.message);
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADER_FALSE" });
            if (err && err.data) {
            toaster("error", err.data.message);
            }
        });
    };
    };

    export const d2cOfflinePayment = (data, cb) => {
    return (dispatch) => {
        dispatch({ type: "LOADER_TRUE" });
        axios
        .post(
            `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/payment`,
            data,
            {
            headers: {
                authorization: localStorage.getItem("token"),
            },
            }
        )
        .then((res) => {
            dispatch({ type: "LOADER_FALSE" });
            if (res && res.data) {
            dispatch(getProposalDetails(data.proposalNumber));
            dispatch({
                type: actionTypes.PAYMENT_D2C_OFFLINE,
                data: res.data,
            });
            if(cb){
                cb()
            }
            toaster("success", res.data.message);
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADER_FALSE" });
            if (err && err.data) {
            toaster("error", err.data.message);
            }
        });
    };
    };

    export const neftPayment = (data, propNo) => {
    return (dispatch) => {
        dispatch({ type: "LOADER_TRUE" });
        axios
        .post(
            `${
            apiConstants().PROPOSEL_API_URL
            }api/v1/proposal/ops/payment/neft?proposalNumber=${propNo}`,
            data,
            {
            headers: {
                authorization: localStorage.getItem("token"),
            },
            }
        )
        .then((res) => {
            dispatch({ type: "LOADER_FALSE" });
            if (res && res.data) {
            dispatch(getProposalDetails(propNo));
            dispatch({
                type: actionTypes.PAYMENT_D2C_OFFLINE,
                data: res.data,
            });
            toaster("success", res.data.message);
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADER_FALSE" });
            if (err && err.data) {
            toaster("error", err.data.message);
            }
        });
    };
    };

    export const deletePaymentMethod = (propId, id, cb) => (dispatch) => {
    dispatch({
        type: actionTypes.LOADER_TRUE,
    });
    axios
        .delete(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/payment/delete`,
        {
            headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
            proposalnumber: propId,
            id: id,
            },
        }
        )
        .then((resp) => {
        if (resp.data.body) {
            dispatch(getProposalDetails(propId));
        }
        toaster("success", resp.data.message);
        if (cb) {
            cb(resp.data.body);
        }
        dispatch({
            type: actionTypes.LOADER_FALSE,
        });
        })
        .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
            toaster("error", err.data.message);
        }
        });
    };

    export const deletePaymentMethodMcustomerAPI = (propId, id, cb) => (dispatch) => {
        dispatch({
            type: actionTypes.LOADER_TRUE,
        });
        axios
            .delete(
            `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/payment/delete`,
            {
                headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token"),
                proposalnumber: propId,
                id: id,
                },
            }
            )
            .then((resp) => {
            if (resp.data.body) {
                dispatch(getProposalDetails(propId));
            }
            toaster("success", resp.data.message);
            if (cb) {
                cb(resp.data.body);
            }
            dispatch({
                type: actionTypes.LOADER_FALSE,
            });
            })
            .catch((err) => {
            dispatch({ type: "LOADER_FALSE" });
            if (err && err.data) {
                toaster("error", err.data.message);
            }
            });
    };

    export const approvePayment = (data, cb) => (dispatch) => {
    axios
        .post(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/payment/approve`,
        data,
        {
            headers: {
            authorization: localStorage.getItem("token"),
            },
        }
        )
        .then((res) => {
        toaster("succes",res.data.message);

        if (cb) cb();
    })
    .catch((err) => console.log("err", err));
};

export const getReconciliationData = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.get(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/user-payment-data?branchName=${payload.branchName}&userId=${payload.userId}&zone=${payload.zone}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};

export const saveReconciliationEditData = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.post(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/reconcile-editable/save`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};

export const FinalReconcileCall = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.post(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/reconcile`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};

export const getReconciliationReport = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.get(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/reconciliation/date-range?branchName=${payload.branchName}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&userId=${payload.userId}&zone=${payload.zone}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};

export const getBankingReportData = (branchName, userId, zone) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.get(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/banking/previous-day?branchName=${branchName}&userId=${userId}&zone=${zone}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};

export const saveBankingReport = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.post(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/banking/save`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res.status===200 && res.data.body) {
        toaster("success", 'Banking Report Saved Successfully');
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};
export const getDateRangeData = (branchName, fromDate, toDate, userId, zone) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.get(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/banking/date-range?branchName=${branchName}&fromDate=${fromDate}&toDate=${toDate}&userId=${userId}&zone=${zone}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};

export const getUpfrontPaymentReport = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const res = await axios.get(
        `${apiConstants().PROPOSEL_API_URL}api/upfront-payments/date-range?fromDate=${payload?.fromDate}&toDate=${payload?.toDate}&proposalNumber=${payload?.proposalNumber ? payload?.proposalNumber : ""}&size=${payload?.size}&page=${payload?.page}&export=${payload?.export}`,
        
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        toaster("success", res.data.message);
        return res.data
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};